import axios from 'axios'
import store from '@/store'
import router from '@/router'
import swal from 'sweetalert2'

// URL API
axios.defaults.baseURL = process.env.VUE_APP_API_URL || '';

// Request interceptor
axios.interceptors.request.use(request => {
  const token = store.getters['auth/token']
  if (token) {
    request.headers.common['Authorization'] = `Bearer ${token}`
  }

  // const locale = store.getters['lang/locale']
  // if (locale) {
  //   request.headers.common['Accept-Language'] = locale
  // }

  // request.headers['X-Socket-Id'] = Echo.socketId()

  return request
})

// Response interceptor
axios.interceptors.response.use(response => response, error => {
  const { status } = error.response

  if (status >= 500) {
    swal.fire({
      type: 'error',
      title: 'Error',
      text: 'Ocurrió un error',
      reverseButtons: true,
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancelar'
    })
  }
  if (status === 401 && store.getters['auth/check']) {
    
    swal.fire({
      type: 'warning',
      title: 'Token Expirado',
      text: 'El tiempo de vida del token expiró',
      reverseButtons: true,
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancelar'
    }).then(async () => {
      await store.dispatch('auth/logout')

      router.push({ name: 'login' })
    })
  }

  return Promise.reject(error)
})
